import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import lodash from 'lodash';
import {getRecaptchaToken} from '../../../utilities/recaptcha/recaptcha';
import {
  formatDatesToDifferentFormats,
  getPackageEndDate,
  getFamilyBundleInstallPhones,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadUtilities';
import {
  openModal,
  verifyPhone,
  validatePhoneHandler,
  validateOtpCodeHandler,
  hideOtpErrorMessage,
  setOtpVerifyCode,
  clearOtpCode,
  abroadRetrieveCustomerData,
  checkFamilyBundleSubscribersBlockage,
  finalizeFamilyBundleInstallValidation,
  validateOtpDataWithCustomerRequest,
  abroadRetrieveCustomerDataFamily,
  setSurfBlockedSubscriberPhones,
  RemoveAndAddShadowSoc,
  readyToPurchasePackageFamily,
  GetShadowSubscriberData,
  validateCustomerTypeBusinessIndividual,
  setBackupCG,
  displayRestrictedCodePopup,
  setOtpPopupData,
  validateOtpCode,
  clearOtpForm,
  setSaleOtpStep,
  setSaleOtpChildrenStep,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {createOtpLoginStep02, setRestrictedCodeError, setOtpError} from 'app/utilities/authentication/authenticationSlice';
import {otpOrigin, originProcess} from 'app/Components/Block/OTPLoginBlock/Assets/variables';
import {isBrowser, isMobile} from 'react-device-detect';
import {
  saleOTPSteps,
  customerTypeEnum,
  lobbyTabsEnum,
  popupReasonEnum,
  otpValidationPopupContent,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent, gtag4} from '../../../utilities/analytics/tracking';
import {resetStore} from '../SaleBlock/PaymentCG/PaymentCGSlice';
import {gaClickOnAddPackageButton} from './gaReports';
import {enqueueRequest} from '../../../utilities/apiQueue';

function StepBtn(props) {
  useEffect(() => {
    return () => {
      props.clearOtpForm();
      props.setOtpError(null);
      props.setRestrictedCodeError(null);
    };
  }, []);
  const [btnClicked, setBtnClicked] = useState(false);

  const hasError = props.form && props.form.errors && props.form.errors.phone != '';
  const checkBoxCollaborationVal = props.checkBoxCollaborationChecked;
  const authError =
    props.authentication?.loginData?.isFullAuthenticated && !props.data.otpData.isOTPValidated && !props.data?.otpData?.isFamilyProcess;
  useEffect(() => {
    if (props.data?.otpData?.isFamilyProcess) {
      if (props.data?.comingFromPackageManager) {
        if (props.data?.otpDataChildren?.saleOTPStep === saleOTPSteps.OTP) {
          gaEvent(
            gaParams.ABROAD_FAMILY_DISPLAY_OTP_INPUT_BOXES.category,
            gaParams.ABROAD_FAMILY_DISPLAY_OTP_INPUT_BOXES.eventType,
            gaParams.ABROAD_FAMILY_DISPLAY_OTP_INPUT_BOXES.eventParams,
          );
        }

        if (props.data?.otpDataChildren?.saleOTPStep === saleOTPSteps.AFTER_INPUT) {
          gaEvent(
            gaParams.ABROAD_FAMILY_DISPLAY_SUMMAY_TICKET_POST_OTP.category,
            gaParams.ABROAD_FAMILY_DISPLAY_SUMMAY_TICKET_POST_OTP.eventType,
            gaParams.ABROAD_FAMILY_DISPLAY_SUMMAY_TICKET_POST_OTP.eventParams,
          );
        }
      } else {
        if (props.data?.otpDataChildren?.saleOTPStep === saleOTPSteps.OTP) {
          gaEvent(
            gaParams.ABROAD_FAMILY_DISPLAY_OTP_INPUT_BOXES_TICKET_FLOW.category,
            gaParams.ABROAD_FAMILY_DISPLAY_OTP_INPUT_BOXES_TICKET_FLOW.eventType,
            gaParams.ABROAD_FAMILY_DISPLAY_OTP_INPUT_BOXES_TICKET_FLOW.eventParams,
          );
        }

        if (props.data?.otpDataChildren?.saleOTPStep === saleOTPSteps.AFTER_INPUT) {
          gaEvent(
            gaParams.ABROAD_FAMILY_DISPLAY_SUMMAY_TICKET_POST_OTP_TICKET_FLOW.category,
            gaParams.ABROAD_FAMILY_DISPLAY_SUMMAY_TICKET_POST_OTP_TICKET_FLOW.eventType,
            gaParams.ABROAD_FAMILY_DISPLAY_SUMMAY_TICKET_POST_OTP_TICKET_FLOW.eventParams,
          );
        }
      }
    }
  }, [props.data?.otpDataChildren?.saleOTPStep, props.data?.otpData?.isFamilyProcess, props.data?.comingFromPackageManager]);

  const validateAndSubmitPackage = () => {
    // Check if this is a family bundle and validate member selection
    if (props.data.selectedAbroadPackage?.isFamilyBundle) {
      // First check if terms checkbox is checked
      if (!props.checkBoxChecked) {
        setBtnClicked(false);
        props.setErrorMessageText('כדי להמשיך יש לאשר את תנאי החבילה');
        props.setShowMessage(true);
        return;
      }

      // Check if flight manager is selected
      const flightManager = props.data?.familyBundleData?.flightManager;
      if (!flightManager || !flightManager.phone) {
        setBtnClicked(false);
        props.setErrorMessageText('יש לבחור מנהל טיסה');
        props.setShowMessage(true);
        return;
      }

      const selectedMembers = props.data?.familyBundleData?.selectedMembers || [];
      const additionalMembers = selectedMembers.filter((member) => {
        const phone = typeof member === 'string' ? member : member.phone;
        return phone !== flightManager?.phone;
      });

      // Check if user chose to bypass member validation (continue without members)
      const bypassMemberValidation = props.data?.familyBundleData?.bypassMemberValidation;

      // If no additional members selected and not bypassing, show popup
      if (additionalMembers.length === 0 && !bypassMemberValidation) {
        console.log('Opening NO_MEMBERS_SELECTED popup', {
          selectedMembers,
          flightManager,
          additionalMembers,
          isShowPopup: props.data.isShowPopup,
          popupReason: props.data.popupReason,
        });
        setBtnClicked(false);
        props.openModal(popupReasonEnum.NO_MEMBERS_SELECTED);
        return;
      }
    }

    setBtnClicked(true);
    gaClickOnAddPackageButton(
      props.businessOrPrivate,
      props.data.startedFromPackage,
      props.data.otpData.validatedCostumerData?.isSeparatedSale,
      props.data.epiStyleInitializationData.businessIndividualLobby,
    );

    if (props.data.shadowClientBillData && props.data.shadowClientBillData.shouldUpdate && !props.data.shadowUpdatedCC) {
      props.setPaymentErrorMessage(true);
      if (!props.checkBoxChecked) {
        setBtnClicked(false);
        props.setShowMessage(true);
      }
    } else {
      if (props.checkBoxChecked) {
        if (!props.data.epiStyleInitializationData.businessIndividualLobby) {
          if (props.data.otpData.validatedCostumerData.isSeparatedSale) {
            const shadowDataToSend = {
              idNumber: props.data.shadowForm.customerId,
              firstName: props.data.shadowForm.customerFirstName,
              lastName: props.data.shadowForm.customerLastName,
              subscriber: props.data.otpData.otpPhone,
              ccMonth: props.paymentCG.form.CardDueMonth,
              ccYear: props.paymentCG.form.CardDueYear,
              ccType: props.paymentCG.CCType,
              ccNumber: props.paymentCG.CCToken,
              authNum: props.paymentCG?.CGData?.authNumber,
              clientMail: props.data.shadowForm.customerEmail,
              socCode: props.data.selectedAbroadPackage.socCode,
              referenceSocCode: props.data.selectedAbroadPackage.socCode,
              shadowBan: props.data.otpData.validatedCostumerData.shadowData.ban,
              startDate: props.data.dates.selectedStartDate,
              endDate: props.data.dates.selectedEndDate,
              countries: lodash.map(props.data.selectedCountries, 'countryCode'),
              blockId: props.data.epiStyleInitializationData.lobbyBlockId,
              couponSerial: props.data.coupon?.voucherCategory || '',
              couponCode: props.data.coupon?.code || '',
              fromExisting:
                props.data.shadowForm.customerEmail != '' &&
                props.data.otpData.validatedCostumerData.shadowData.ban &&
                props.data.otpData.validatedCostumerData.shadowData.ban != '0' &&
                props.data.otpData.validatedCostumerData.shadowData.ban != '-1',
            };
            props.activateAnimation();
            setTimeout(() => {
              props.RemoveAndAddShadowSoc(shadowDataToSend).then((res) => {
                props.resetStore();
                props.setBackupCG(null);
                props.GetShadowSubscriberData({subscriber: props.data.otpData.otpPhone});
              });
            }, 2500);
            return;
          } else {
            if (props.data.otpData.validatedCostumerData.accountType == customerTypeEnum.UNKNOWN) {
              let validationObj = props.validateOtpDataWithCustomerRequest(props.data.otpData.validatedCostumerData);
              if (validationObj && validationObj != 'SeparatedSale') {
                props.openModal(popupReasonEnum.OTP_RESULT);
              }
              return;
            }
          }
        }

        const dispatchAbroadRetrieveCustomerData = () => {
          const startDate = formatDatesToDifferentFormats(props.data.dates.datePickerStartJSFormat).formattedProvider;
          const endDate = formatDatesToDifferentFormats(props.data.dates.datePickerEndJSFormat).formattedProvider;

          const abroadRetrieveCustomerDataObject = {
            socCode: props.data.selectedAbroadPackage.socCode,
            startDate: startDate,
            endDate: endDate,
            countries: lodash.map(props.data.selectedCountries, 'countryCode'),
          };

          if (!props.data.epiStyleInitializationData.businessIndividualLobby) {
            (abroadRetrieveCustomerDataObject.phoneNumber = props.data.otpData.otpPhone),
              (abroadRetrieveCustomerDataObject.type = props.data.otpData.validatedCostumerData.accountType),
              (abroadRetrieveCustomerDataObject.blockId =
                props.data.activeLobbyTab == lobbyTabsEnum.PRIVATE
                  ? props.data.epiStyleInitializationData.privateSocPackageFolderId
                  : props.data.epiStyleInitializationData.businessSocPackageFolderId);
            props.abroadRetrieveCustomerData(abroadRetrieveCustomerDataObject);
          } else {
            (abroadRetrieveCustomerDataObject.phoneNumber = props.data.businessIndividualData.selectedAccountNumber),
              (abroadRetrieveCustomerDataObject.packageSegment = props.data.selectedAbroadPackage.packageSegment),
              (abroadRetrieveCustomerDataObject.type = customerTypeEnum.BUSINESS),
              (abroadRetrieveCustomerDataObject.orgId = props.portalsBlock.privateCompanyList.find(
                (org) => org.idNumber == props.portalsBlock.selectedHetPay,
              ).orgId);
            props.validateCustomerTypeBusinessIndividual(abroadRetrieveCustomerDataObject);
          }
        };

        const proceedWithAbroadRetrieveCustomerData = ({skipAnimation = false} = {}) => {
          if (!skipAnimation) {
            props.activateAnimation();
          }

          enqueueRequest(() => {
            dispatchAbroadRetrieveCustomerData();
          });
        };

        if (props.data.selectedAbroadPackage?.isFamilyBundle) {
          const isDataFamilyBundle =
            props.data.selectedAbroadPackage.type && String(props.data.selectedAbroadPackage.type).toUpperCase().includes('DATA');

          if (!isDataFamilyBundle) {
            proceedWithAbroadRetrieveCustomerData();
            return;
          }

          const startDate = formatDatesToDifferentFormats(props.data.dates.datePickerStartJSFormat).formattedProvider;
          const endDate = formatDatesToDifferentFormats(props.data.dates.datePickerEndJSFormat).formattedProvider;
          const blockId =
            props.data.activeLobbyTab == lobbyTabsEnum.PRIVATE
              ? props.data.epiStyleInitializationData.privateSocPackageFolderId
              : props.data.epiStyleInitializationData.businessSocPackageFolderId;

          props
            .checkFamilyBundleSubscribersBlockage({
              phones: getFamilyBundleInstallPhones(props.data.familyBundleData),
              primaryPhone: props.data.familyBundleData.flightManager?.phone,
              socCode: props.data.selectedAbroadPackage.socCode,
              startDate,
              endDate,
              type: props.data.otpData.validatedCostumerData.accountType,
              countries: lodash.map(props.data.selectedCountries, 'countryCode'),
              blockId,
              packageType: props.data.selectedAbroadPackage.type,
            })
            .then((result) => {
              if (checkFamilyBundleSubscribersBlockage.rejected.match(result)) {
                setBtnClicked(false);
                return;
              }
              if (result.payload?.hasBlocked) {
                setBtnClicked(false);
                props.setSurfBlockedSubscriberPhones(result.payload.blockedPhones || []);
                props.openModal(popupReasonEnum.DATA_USAGE_IS_BLOCKED);
                return;
              }
              props.finalizeFamilyBundleInstallValidation({
                primaryResult: result.payload.primaryResult,
                validatedPhone: result.payload.primaryPhone,
              });
            });
          return;
        }

        proceedWithAbroadRetrieveCustomerData();
      } else {
        setBtnClicked(false);
        props.setShowMessage(true);
      }
    }
  };

  const validateAndSubmitPackageFamily = () => {
    setBtnClicked(true);
    if (props.data?.comingFromPackageManager) {
      gaEvent(
        gaParams.ABROAD_FAMILY_CLICK_INSTALL_PACKAGE.category,
        gaParams.ABROAD_FAMILY_CLICK_INSTALL_PACKAGE.eventType,
        gaParams.ABROAD_FAMILY_CLICK_INSTALL_PACKAGE.eventParams,
      );
    } else {
      gaEvent(
        gaParams.ABROAD_FAMILY_CLICK_INSTALL_PACKAGE_TICKET_FLOW.category,
        gaParams.ABROAD_FAMILY_CLICK_INSTALL_PACKAGE_TICKET_FLOW.eventType,
        gaParams.ABROAD_FAMILY_CLICK_INSTALL_PACKAGE_TICKET_FLOW.eventParams,
      );
    }

    if (props.checkBoxChecked) {
      props.activateAnimation();

      enqueueRequest(() => {
        const startDateChildren = formatDatesToDifferentFormats(props.data.dates.datePickerStartJSFormat).formattedProvider;
        const endDateChildren = getPackageEndDate(
          props.data.dates.datePickerStartJSFormat,
          props.data.selectedAbroadPackage?.packageDuration,
        ).formattedProvider;

        let blockId =
          props.data.otpDataChildren.isOTPValidated &&
          props.data.otpDataChildren.validatedCostumerData?.accountType == customerTypeEnum.BUSINESS
            ? props.data.epiStyleInitializationData.businessSocPackageFolderId
            : props.data.epiStyleInitializationData.privateSocPackageFolderId;
        const otpObj = {
          SubscriberNoParent: props.data.otpData.otpPhone,
          SubscriberChildren: props.data.otpDataChildren.otpPhone,
          // OtpTicketChildren: props.data.otpDataChildren.step1Ticket,
          SocCodeFamilyPackage: props.data.selectedAbroadPackage?.socCode,
          SocCodePackageGiveFamilyBonus: props.data.otpData?.socCodeParent,
          StartDateChildren: startDateChildren,
          EndDateChildren: endDateChildren,
          StartDateParent: props.data.otpData.startDateParent,
          Countries:
            props.data.otpData?.isFamilyProcess && props.data?.fromPackageManagerToTicket
              ? props.data.selectedCountriesFamily.map((x) => x.countryCode)
              : props.data.selectedCountries.map((x) => x.countryCode),
          BlockId: blockId,
        };
        if (!props.authentication?.loginData?.isFullAuthenticated) {
          otpObj.OtpTicketChildren = props.data.otpDataChildren.step1Ticket;
        }

        props.abroadRetrieveCustomerDataFamily(otpObj);
      });
    } else {
      setBtnClicked(false);
      props.setShowMessage(true);
    }
  };

  const handleOTPVerifyPhoneValidate = () => {
    if (props.data.startedFromPackage) {
      gtag4({
        event: 'CellcomAbroad_Step4_OtpButton',
        button: 'שליחת קוד אימות',
        step: '4',
        action: 'OtpButton',
        process_type: 'private',
        funnel_name: '3 - Package',
      });
    } else {
      gtag4({
        event: 'CellcomAbroad_Step7_OtpButton',
        button: 'שליחת קוד אימות',
        step: '7',
        action: 'OtpButton',
        process_type: 'private',
        funnel_name: '2 - SearchArea',
      });
    }

    if (props?.data?.otpData?.isFamilyProcess && props.data?.comingFromPackageManager) {
      gaEvent(
        gaParams.ABROAD_FAMILY_CLICK_SEND_VEREFICATION_CODE.category,
        gaParams.ABROAD_FAMILY_CLICK_SEND_VEREFICATION_CODE.eventType,
        gaParams.ABROAD_FAMILY_CLICK_SEND_VEREFICATION_CODE.eventParams,
      );
    }
    props.validatePhoneHandler({form: props.data.otpPhoneForm}).then(function (result) {
      if (result.payload.valid) {
        OtpVerifyPhone(false);
      }
    });
  };

  async function OtpVerifyPhone(isVoice) {
    const captchaToken = await getRecaptchaToken('OtpVerifyPhonePage');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }
    await props.verifyPhone({
      phoneNumber: props.data.otpPhoneForm.phone,
      asVoice: isVoice,
      captchaToken: captchaToken,
      otpOrigin: otpOrigin.ABROAD,
      originProcess: originProcess.TICKET,
    });
  }

  const handleOTPVerifyCodeValidate = () => {
    if (props.data?.otpData?.isFamilyProcess) {
      if (props.data?.comingFromPackageManager) {
        gaEvent(
          gaParams.ABROAD_FAMILY_CLICK_CONTINUE_BTN_FOLLOW_OTP_INPUT.category,
          gaParams.ABROAD_FAMILY_CLICK_CONTINUE_BTN_FOLLOW_OTP_INPUT.eventType,
          gaParams.ABROAD_FAMILY_CLICK_CONTINUE_BTN_FOLLOW_OTP_INPUT.eventParams,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_FAMILY_CLICK_CONTINUE_BTN_FOLLOW_OTP_INPUT_TICKET_FLOW.category,
          gaParams.ABROAD_FAMILY_CLICK_CONTINUE_BTN_FOLLOW_OTP_INPUT_TICKET_FLOW.eventType,
          gaParams.ABROAD_FAMILY_CLICK_CONTINUE_BTN_FOLLOW_OTP_INPUT_TICKET_FLOW.eventParams,
        );
      }
    }
    props.validateOtpCodeHandler({form: props.data.otpCodeForm}).then(async function (result) {
      if (props.data.otpData?.isFamilyProcess) {
        props.setSaleOtpChildrenStep(saleOTPSteps.LOADER);
      } else {
        props.setSaleOtpStep(saleOTPSteps.LOADER);
      }

      props.setOtpError(null);
      props.setRestrictedCodeError(null);
      if (result.payload.valid) {
        if (props.data.restrictedCodeRequired) {
          props.displayRestrictedCodePopup(true);
        } else {
          if (props.data.otpData?.isFamilyProcess)
            props
              .validateOtpCode({
                otpPhone: props.data.otpDataChildren.otpPhone,
                otpTicketId: props.data.otpDataChildren.step1Ticket,
                otpCode: props.data.otpCodeForm.verifyCode,
                otpOrigin: otpOrigin.ABROAD,
                originProcess: originProcess.TICKET,
              })
              .then((res) => {
                if (!res.payload.error) {
                  props.submitValidateCustomerType();
                }
              });
          else {
            const otpData = props.data.otpData;
            const otpCodeForm = props.data.otpCodeForm;
            const phoneNumber = otpData.otpPhone;
            const guid = otpData.step1Ticket;

            await props
              .createOtpLoginStep02({
                phoneNumber,
                otpCode: otpCodeForm.verifyCode,
                guid,
                otpOrigin: otpOrigin.ABROAD,
                originProcess: originProcess.TICKET,
              })
              .then((res) => {
                if (res.payload.isSuccess) {
                  props.submitValidateCustomerType();
                } else if (res.payload.codeError === '39') {
                  props.setOtpPopupData(otpValidationPopupContent.isNotCellcomAccount);
                  props.openModal(popupReasonEnum.OTP_RESULT);
                } else if (res.payload.codeError === '750') {
                  props.setOtpError('לא ניתן להתקדם לרכישה, יש לפנות לשירות לקוחות ב- *' + window.Config.technicalSupportPhone);
                }
              });
          }
        }
      }
    });
  };

  const checkIfNumberIsValid = () => {
    setBtnClicked(true);
    if (
      !props.data.epiStyleInitializationData.businessIndividualLobby &&
      !props.data.isJETAuthentication &&
      props.authentication?.loginData?.isFullAuthenticated &&
      (props.data.relatedPhoneNumbers?.length == 0 ||
        (props.data.relatedPhoneNumbers?.length > 0 && !props.data.relatedPhoneNumbers.includes(props.data.otpData.otpPhone)))
    ) {
      return null;
    } else if (props.data.businessIndividualData?.isFullFinancing) {
      if (!props.checkBoxChecked) {
        props.setShowMessage(true);
      } else {
        props.openModal(popupReasonEnum.ENABLE_INDEPENDENT_PURCHASE);
      }

      setBtnClicked(false);
    } else {
      validateAndSubmitPackage();
    }
  };

  function renderBtnByStep(step) {
    switch (step) {
      case saleOTPSteps.MOBILE_INPUT:
        return <BtnSubmit text={'שליחת קוד אימות'} onclick={() => handleOTPVerifyPhoneValidate()} disabled={hasError || authError} />;
      case saleOTPSteps.OTP:
        return <BtnSubmit text={'המשך'} onclick={() => handleOTPVerifyCodeValidate()} disabled={hasError || authError} />;
      case saleOTPSteps.LOADER:
        return (
          <BtnSubmit
            text={
              props.data.otpData.step1Ticket || props.data.otpDataChildren.step1Ticket || props.data.otpData.isFamilyProcess
                ? 'המשך'
                : 'שליחת קוד אימות'
            }
          />
        );
      case saleOTPSteps.SELECT_FAMILY_MEMBER:
      case saleOTPSteps.AFTER_INPUT:
        if (props.data.otpData?.isFamilyProcess)
          return (
            <div className='w-100'>
              <BtnSubmit text={'להתקנת החבילה'} onclick={() => (btnClicked ? null : validateAndSubmitPackageFamily())} />
            </div>
          );
        else
          return (
            <div className='w-100'>
              <BtnSubmit text={'להתקנת החבילה'} onclick={() => (btnClicked ? null : checkIfNumberIsValid())} />
            </div>
          );
      default:
        return <BtnSubmit text={'שליחת קוד אימות'} />;
    }
  }

  if (props.data.otpData?.isFamilyProcess) return renderBtnByStep(props.data.otpDataChildren.saleOTPStep);
  else return renderBtnByStep(props.data.otpData.saleOTPStep);
}

const mapStateToProps = (state) => ({
  form: state.cellcomAbroad.otpPhoneForm,
  data: state.cellcomAbroad,
  paymentCG: state.PaymentCG,
  portalsBlock: state.portalsBlock,
  authentication: state.authentication,
});

const mapDispatchToProps = {
  validateOtpDataWithCustomerRequest,
  verifyPhone,
  validatePhoneHandler,
  validateOtpCodeHandler,
  hideOtpErrorMessage,
  setOtpVerifyCode,
  clearOtpCode,
  abroadRetrieveCustomerData,
  checkFamilyBundleSubscribersBlockage,
  finalizeFamilyBundleInstallValidation,
  setSurfBlockedSubscriberPhones,
  openModal,
  abroadRetrieveCustomerDataFamily,
  RemoveAndAddShadowSoc,
  resetStore,
  readyToPurchasePackageFamily,
  GetShadowSubscriberData,
  validateCustomerTypeBusinessIndividual,
  setBackupCG,
  createOtpLoginStep02,
  setRestrictedCodeError,
  setOtpError,
  displayRestrictedCodePopup,
  setOtpPopupData,
  validateOtpCode,
  clearOtpForm,
  setSaleOtpStep,
  setSaleOtpChildrenStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(StepBtn);
